// https://github.com/championswimmer/vuex-module-decorators

import axios from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import { User } from "@/models/definitions";

@Module
export default class Users extends VuexModule {
  users: User[] = [];
  currentUserId = 1;

  @Mutation
  setUsers(users: User[]) {
    this.users = users;
  }

  @Mutation
  setCurrentUserId(userId: number) {
    this.currentUserId = userId;
  }

  @Action({ commit: "setUsers" })
  async fetchUsers() {
    const response = await axios.get<User[]>(
      process.env.VUE_APP_API_ROOT_URL + "api/users"
    );
    return response.data;
  }

  get allUsers(): User[] {
    return this.users;
  }

  get currentUser(): User | undefined {
    return this.users.find((user) => user.id == this.currentUserId);
  }
}
